import { ArrowLeftOutlined, CaretRightOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Collapse,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Space,
  Switch,
  theme,
} from "antd";
import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Heading from "../../../../components/common/heading";
import FailModal from "../../../../components/modal/failModal";
import SuccessModal from "../../../../components/modal/successModal";
import {
  DATA_MASTER_DATA_TYPE,
  PERMISSION,
  SUCCESS_CODE,
} from "../../../../lib/const";
import useCancelModal from "../../../../lib/hooks/useCancelModal";
import useMasterData from "../../../../lib/hooks/useMasterData";
import { routes } from "../../../../routes";
import { getRoleId, updateRoleUser } from "../../../../services/userManagement";
import WithSidebar from "../../../../templates/withSidebar";
import "../../style.css";

const { Panel } = Collapse;
const { TextArea } = Input;

const Options = {
  create: "สร้าง",
  edit: "แก้ไข",
  delete: "ลบ",
  watch: "ดู",
  export: "Export JPG",
};

const appOptions = {
  create: "สร้าง",
  edit: "แก้ไข",
  delete: "ลบ",
  watch: "ดู",
  export: "Export Excel",
};

const applicationOptions = [
  appOptions.create,
  appOptions.edit,
  appOptions.delete,
  appOptions.watch,
  appOptions.export,
];

const CheckboxGroup = Checkbox.Group;
const plainOptions = [
  Options.create,
  Options.edit,
  Options.delete,
  Options.watch,
];
const dashboardOptions = [Options.watch, Options.export];

const panelStyle = {
  marginBottom: 24,
  // background: "#EBF5FF",
  borderRadius: "16px",
  border: "none",
};

const EditUserRoleManagement = () => {
  const navigate = useNavigate();
  const { token } = theme.useToken();
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();
  const { Option } = Select;
  const [form] = Form.useForm();

  const [initPermission, setInitPermission] = useState([]);
  const [permissions] = useMasterData(DATA_MASTER_DATA_TYPE, PERMISSION);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [openFailModal, setOpenFailModal] = useState(false);

  //กรอกผ่าน Application
  const [checkedListApp1, setCheckedListApp1] = useState([]);
  const [checkedListApp2, setCheckedListApp2] = useState([]);
  const [checkedListApp3, setCheckedListApp3] = useState([]);
  const [checkedListApp4, setCheckedListApp4] = useState([]);
  const [checkAllApp1, setCheckAllApp1] = useState(false);
  const [checkAllApp2, setCheckAllApp2] = useState(false);
  const [checkAllApp3, setCheckAllApp3] = useState(false);
  const [checkAllApp4, setCheckAllApp4] = useState(false);
  const [checkAllEstate1, setCheckAllEstate1] = useState(false);
  const [indeterminateApp1, setIndeterminateApp1] = useState(false);
  const [indeterminateApp2, setIndeterminateApp2] = useState(false);
  const [indeterminateApp3, setIndeterminateApp3] = useState(false);
  const [indeterminateApp4, setIndeterminateApp4] = useState(false);
  const [createEditApp5, setCreateEditApp5] = useState(false);
  const [createEditApp6, setCreateEditApp6] = useState(false);
  const [viewApp5, setViewApp5] = useState(false);
  const [viewApp6, setViewApp6] = useState(false);
  const [allYearOfBudgetApp5, setAllYearOfBudgetApp5] = useState(false);
  const [allYearOfBudgetApp6, setAllYearOfBudgetApp6] = useState(false);

  const [checkExportPDFApp7, setCheckExportPDFApp7] = useState(false);
  const [checkExportPDFApp8, setCheckExportPDFApp8] = useState(false);

  //นำเข้าข้อมูล Raw Data
  const [checkedListRawData1, setCheckedListRawData1] = useState([]);
  const [checkedListRawData2, setCheckedListRawData2] = useState([]);
  const [checkAllRawData1, setCheckAllRawData1] = useState(false);
  const [checkAllRawData2, setCheckAllRawData2] = useState(false);
  const [indeterminateRawData1, setIndeterminateRawData1] = useState(false);
  const [indeterminateRawData2, setIndeterminateRawData2] = useState(false);

  //ค้นหา/แก้ไขข้อมูล
  const [checkedListAction1, setCheckedListAction1] = useState([]);
  const [checkedListAction2, setCheckedListAction2] = useState([]);
  const [indeterminateAction1, setIndeterminateAction1] = useState(false);
  const [indeterminateAction2, setIndeterminateAction2] = useState(false);
  const [checkAllAction1, setCheckAllAction1] = useState(false);
  const [checkAllAction2, setCheckAllAction2] = useState(false);

  //Dashboard
  const [checkedListDashboard1, setCheckedListDashboard1] = useState([]);
  const [checkedListDashboard2, setCheckedListDashboard2] = useState([]);
  const [checkedListDashboard3, setCheckedListDashboard3] = useState([]);
  const [checkedListDashboard4, setCheckedListDashboard4] = useState([]);
  const [checkedListDashboard5, setCheckedListDashboard5] = useState([]);
  const [indeterminateDashboard1, setIndeterminateDashboard1] = useState(false);
  const [indeterminateDashboard2, setIndeterminateDashboard2] = useState(false);
  const [indeterminateDashboard3, setIndeterminateDashboard3] = useState(false);
  const [indeterminateDashboard4, setIndeterminateDashboard4] = useState(false);
  const [indeterminateDashboard5, setIndeterminateDashboard5] = useState(false);
  const [checkAllDashboard1, setCheckAllDashboard1] = useState(false);
  const [checkAllDashboard2, setCheckAllDashboard2] = useState(false);
  const [checkAllDashboard3, setCheckAllDashboard3] = useState(false);
  const [checkAllDashboard4, setCheckAllDashboard4] = useState(false);
  const [checkAllDashboard5, setCheckAllDashboard5] = useState(false);

  const [loading, setLoading] = useState(false);
  const [submittable, setSubmittable] = useState(false);

  const [displayEnable, setDisplayEnable] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const params = useParams();
  const values = Form.useWatch([], form);

  const onFinish = async (values) => {
    const request = {
      requestObject: {
        roleId: params.id,
        roleNameEn: "",
        roleNameTh: values?.roleNameTh,
        permissionId: values?.permission,
        description: values?.description,
        recStatus: values?.status === true ? "A" : "D",
        authorization: [
          {
            authorizeId: "073eb767-f7a1-4b93-98db-b3827bd45fd5",
            authorizeNameEn: "Customer Visit",
            authorizeNameTh: "Customer Visit",
            roleId: params.id,
            authorizeTopicId: "b9d77677-8a83-4059-6b91-1ec9b2803acb",
            permission: [
              {
                permissionId: "87a73d9d-33e8-4a21-8641-29b3e9bc7ff8",
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                authorizeId: "073eb767-f7a1-4b93-98db-b3827bd45fd5",
                isSelected: checkAllDashboard3 ? true : false,
              },
              {
                permissionId: "9c044119-ad55-4293-843c-13dcf53e98d4",
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                authorizeId: "073eb767-f7a1-4b93-98db-b3827bd45fd5",
                isSelected: checkedListDashboard3.includes("ดู") ? true : false,
              },
              {
                permissionId: "d2bc0667-ae92-48f1-8cd5-5237242806e1",
                permissionNameEn: "Export JPG",
                permissionNameTh: "นำออกข้อมูล",
                authorizeId: "073eb767-f7a1-4b93-98db-b3827bd45fd5",
                isSelected: checkedListDashboard3.includes("นำออกข้อมูล")
                  ? true
                  : false,
              },
            ],
          },
          {
            authorizeId: "0cdf2ead-40e8-41d6-b9c3-49448545b41d",
            authorizeNameEn: "Future Customer",
            authorizeNameTh: "ข้อมูลลูกค้าอนาคต",
            roleId: params.id,
            authorizeTopicId: "1cdf4ad0-8c1f-f4db-8965-26606ffa8ed1",
            permission: [
              {
                permissionId: "06d10f30-5b74-4586-b6fd-12d8393bb0ed",
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                authorizeId: "0cdf2ead-40e8-41d6-b9c3-49448545b41d",
                isSelected: checkedListApp2.includes("ดู") ? true : false,
              },
              {
                permissionId: "11daa42c-7bc2-491f-bc15-406dd087262e",
                permissionNameEn: "Delete",
                permissionNameTh: "ลบ",
                authorizeId: "0cdf2ead-40e8-41d6-b9c3-49448545b41d",
                isSelected: checkedListApp2.includes("ลบ") ? true : false,
              },
              {
                permissionId: "382e3c53-67b2-468b-be06-df642ee23512",
                permissionNameEn: "Edit",
                permissionNameTh: "แก้ไข",
                authorizeId: "0cdf2ead-40e8-41d6-b9c3-49448545b41d",
                isSelected: checkedListApp2.includes("แก้ไข") ? true : false,
              },
              {
                permissionId: "3e01ded0-fbf4-4a49-a5b4-007abbbc7294",
                permissionNameEn: "Create",
                permissionNameTh: "สร้าง",
                authorizeId: "0cdf2ead-40e8-41d6-b9c3-49448545b41d",
                isSelected: checkedListApp2.includes("สร้าง") ? true : false,
              },
              {
                permissionId: "3e01ded0-fbf4-4a49-a5b4-007abbbc7294",
                permissionNameEn: "Export Excel",
                permissionNameTh: "Export Excel",
                authorizeId: "0cdf2ead-40e8-41d6-b9c3-49448545b41d",
                isSelected: checkedListApp2.includes("Export Excel")
                  ? true
                  : false,
              },
              {
                permissionId: "a0bac2b9-0ed7-4de9-8a29-193d562af4ca",
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                authorizeId: "0cdf2ead-40e8-41d6-b9c3-49448545b41d",
                isSelected: checkAllApp2 ? true : false,
              },
            ],
          },
          {
            authorizeId: "0d902bed-f963-4f6d-a91b-fb8520aa4d9a",
            authorizeNameEn: "Current Customer",
            authorizeNameTh: "ข้อมูลลูกค้าปัจจุบัน",
            roleId: params.id,
            authorizeTopicId: "1cdf4ad0-8c1f-f4db-8965-26606ffa8ed1",
            permission: [
              {
                permissionId: "1d9a9c29-9f17-4367-a6d5-9139abd5bf62",
                permissionNameEn: "Edit",
                permissionNameTh: "แก้ไข",
                authorizeId: "0d902bed-f963-4f6d-a91b-fb8520aa4d9a",
                isSelected: checkedListApp1.includes("แก้ไข") ? true : false,
              },
              {
                permissionId: "2b0e8332-f2ae-4770-a0b8-a4509e9c9d4c",
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                authorizeId: "0d902bed-f963-4f6d-a91b-fb8520aa4d9a",
                isSelected: checkAllApp1,
              },
              {
                permissionId: "b2df9699-7aac-4cee-84d9-bcd97666292e",
                permissionNameEn: "Create",
                permissionNameTh: "สร้าง",
                authorizeId: "0d902bed-f963-4f6d-a91b-fb8520aa4d9a",
                isSelected:
                  checkedListApp1 && checkedListApp1.includes("สร้าง")
                    ? true
                    : false,
              },
              {
                permissionId: "c66bda2b-c66b-4b08-bc90-6c8917768e03",
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                authorizeId: "0d902bed-f963-4f6d-a91b-fb8520aa4d9a",
                isSelected: checkedListApp1.includes("ดู") ? true : false,
              },
              {
                permissionId: "e41e4c97-1745-4ee6-9678-254c682f3dbd",
                permissionNameEn: "Delete",
                permissionNameTh: "ลบ",
                authorizeId: "0d902bed-f963-4f6d-a91b-fb8520aa4d9a",
                isSelected: checkedListApp1.includes("ลบ") ? true : false,
              },
              {
                permissionId: "e41e4c97-1745-4ee6-9678-254c682f3dbd",
                permissionNameEn: "Export Excel",
                permissionNameTh: "Export Excel",
                authorizeId: "0d902bed-f963-4f6d-a91b-fb8520aa4d9a",
                isSelected: checkedListApp1.includes("Export Excel")
                  ? true
                  : false,
              },
              {
                permissionId: "e41e4c97-1745-4ee6-9678-254c682f3dbd",
                permissionNameEn: "Access all estates",
                permissionNameTh: "เข้าถึงข้อมูลทุกนิคมได้",
                authorizeId: "0d902bed-f963-4f6d-a91b-fb8520aa4d9a",
                isSelected: checkAllEstate1,
              },
            ],
          },
          {
            authorizeId: "1a47ea04-e416-4e88-b63f-8c9c6083ca8f",
            authorizeNameEn: "Stake Holders Data",
            authorizeNameTh: "ข้อมูลผู้มีส่วนได้ส่วนเสีย",
            roleId: params.id,
            authorizeTopicId: "1cdf4ad0-8c1f-f4db-8965-26606ffa8ed1",
            permission: [
              {
                permissionId: "042b4d2d-2516-4769-8702-7cc79a7d3c22",
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                authorizeId: "1a47ea04-e416-4e88-b63f-8c9c6083ca8f",
                isSelected: checkedListApp4.includes("ดู") ? true : false,
              },
              {
                permissionId: "2228b135-a609-44ea-90b2-b827e1cca528",
                permissionNameEn: "Edit",
                permissionNameTh: "แก้ไข",
                authorizeId: "1a47ea04-e416-4e88-b63f-8c9c6083ca8f",
                isSelected: checkedListApp4.includes("แก้ไข") ? true : false,
              },
              {
                permissionId: "593002c5-33e3-4f3e-86cc-1371d6976a73",
                permissionNameEn: "Delete",
                permissionNameTh: "ลบ",
                authorizeId: "1a47ea04-e416-4e88-b63f-8c9c6083ca8f",
                isSelected: checkedListApp4.includes("ลบ") ? true : false,
              },
              {
                permissionId: "61540dc8-81a2-4f54-9272-7a397f997a86",
                permissionNameEn: "Create",
                permissionNameTh: "สร้าง",
                authorizeId: "1a47ea04-e416-4e88-b63f-8c9c6083ca8f",
                isSelected: checkedListApp4.includes("สร้าง") ? true : false,
              },
              {
                permissionId: "76d836f5-f285-4b6c-8376-31a862048bbd",
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                authorizeId: "1a47ea04-e416-4e88-b63f-8c9c6083ca8f",
                isSelected: checkAllApp4 ? true : false,
              },
            ],
          },
          {
            authorizeId: "1a47ea04-e416-4e88-b63f-8c9c6083ca8f",
            authorizeNameEn: "KPI Report",
            authorizeNameTh: "รายงานผลตัวชี้วัด",
            roleId: params.id,
            authorizeTopicId: "1cdf4ad0-8c1f-f4db-8965-26606ffa8ed1",
            permission: [
              {
                permissionId: "042b4d2d-2516-4769-8702-7cc79a7d3c22",
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                authorizeId: "1a47ea04-e416-4e88-b63f-8c9c6083ca8f",
                isSelected: viewApp5 ? true : false,
              },
              {
                permissionId: "2228b135-a609-44ea-90b2-b827e1cca528",
                permissionNameEn: "Create/Update",
                permissionNameTh: "สร้าง/แก้ไข",
                authorizeId: "1a47ea04-e416-4e88-b63f-8c9c6083ca8f",
                isSelected: createEditApp5 ? true : false,
              },
              {
                permissionId: "2228b135-a609-44ea-90b2-b827e1cca528",
                permissionNameEn: "Access all years of budget",
                permissionNameTh: "เข้าถึงข้อมูลทุกปีงบประมาณ",
                authorizeId: "1a47ea04-e416-4e88-b63f-8c9c6083ca8f",
                isSelected: allYearOfBudgetApp5 ? true : false,
              },
            ],
          },
          {
            authorizeId: "1a47ea04-e416-4e88-b63f-8c9c6083ca8f",
            authorizeNameEn: "Performance Report",
            authorizeNameTh: "รายงานผลการดำเนินงานตามแผนปฏิบัติการ",
            roleId: params.id,
            authorizeTopicId: "1cdf4ad0-8c1f-f4db-8965-26606ffa8ed1",
            permission: [
              {
                permissionId: "042b4d2d-2516-4769-8702-7cc79a7d3c22",
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                authorizeId: "1a47ea04-e416-4e88-b63f-8c9c6083ca8f",
                isSelected: viewApp6 ? true : false,
              },
              {
                permissionId: "2228b135-a609-44ea-90b2-b827e1cca528",
                permissionNameEn: "Create/Update",
                permissionNameTh: "สร้าง/แก้ไข",
                authorizeId: "1a47ea04-e416-4e88-b63f-8c9c6083ca8f",
                isSelected: createEditApp6 ? true : false,
              },
              {
                permissionId: "2228b135-a609-44ea-90b2-b827e1cca528",
                permissionNameEn: "Access all years of budget",
                permissionNameTh: "เข้าถึงข้อมูลทุกปีงบประมาณ",
                authorizeId: "1a47ea04-e416-4e88-b63f-8c9c6083ca8f",
                isSelected: allYearOfBudgetApp6 ? true : false,
              },
            ],
          },
          {
            authorizeId: "f936e2ad-3b2c-423c-a181-509af0c048e1",
            authorizeNameEn: "VocReport CurrentCustomer",
            authorizeNameTh: "รายงานจัดอันดับลูกค้าปัจจุบัน",
            roleId: params.id,
            authorizeTopicId: "1cdf4ad0-8c1f-f4db-8965-26606ffa8ed1",
            permission: [
              {
                permissionId: "70ed1e90-d45e-4180-81fb-3d3bf8f7d156",
                permissionNameEn: "Export PDF",
                permissionNameTh: "นำออกข้อมูล PDF",
                authorizeId: "f936e2ad-3b2c-423c-a181-509af0c048e1",
                isSelected: checkExportPDFApp7 ? true : false,
              },
            ],
          },
          {
            authorizeId: "c4f62262-03d6-4304-835a-3f079a4a6bbb",
            authorizeNameEn: "VocReport CurrentCustomer",
            authorizeNameTh: "รายงานจัดอันดับลูกค้าอนาคต",
            roleId: params.id,
            authorizeTopicId: "1cdf4ad0-8c1f-f4db-8965-26606ffa8ed1",
            permission: [
              {
                permissionId: "2159d230-5fd8-4e74-8fdd-23dd0936261c",
                permissionNameEn: "Export PDF",
                permissionNameTh: "นำออกข้อมูล PDF",
                authorizeId: "c4f62262-03d6-4304-835a-3f079a4a6bbb",
                isSelected: checkExportPDFApp8 ? true : false,
              },
            ],
          },
          {
            authorizeId: "29faf5b1-7c0f-4ce6-8fab-362d93ae5809",
            authorizeNameEn: "Current Customer",
            authorizeNameTh: "ข้อมูลลูกค้าปัจจุบัน",
            roleId: params.id,
            authorizeTopicId: "f15f9069-71d0-a6e3-29a7-121206554679",
            permission: [
              {
                permissionId: "0049b608-b58b-4e9a-887e-969547887b24",
                permissionNameEn: "Delete",
                permissionNameTh: "ลบ",
                authorizeId: "29faf5b1-7c0f-4ce6-8fab-362d93ae5809",
                isSelected: checkedListAction1.includes("ลบ") ? true : false,
              },
              {
                permissionId: "3c7294a9-078e-4a8b-9211-8f1a84d6999f",
                permissionNameEn: "Edit",
                permissionNameTh: "แก้ไข",
                authorizeId: "29faf5b1-7c0f-4ce6-8fab-362d93ae5809",
                isSelected: checkedListAction1.includes("แก้ไข") ? true : false,
              },
              {
                permissionId: "47ca60ce-b0e6-4945-8f6d-d09c0466c23e",
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                authorizeId: "29faf5b1-7c0f-4ce6-8fab-362d93ae5809",
                isSelected: checkedListAction1.includes("ดู") ? true : false,
              },
              {
                permissionId: "576e5094-d0be-46c4-8107-57b966935e98",
                permissionNameEn: "Create",
                permissionNameTh: "สร้าง",
                authorizeId: "29faf5b1-7c0f-4ce6-8fab-362d93ae5809",
                isSelected: checkedListAction1.includes("สร้าง") ? true : false,
              },
              {
                permissionId: "999cf7bf-b25b-4ce7-a82c-c89273b7be72",
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                authorizeId: "29faf5b1-7c0f-4ce6-8fab-362d93ae5809",
                isSelected: checkAllAction1 ? true : false,
              },
              {
                permissionId: "cd7bbf9c-7ecd-4e97-8a3d-c5d10fc6d91a",
                permissionNameEn: "Export Excel",
                permissionNameTh: "Export Excel",
                authorizeId: "29faf5b1-7c0f-4ce6-8fab-362d93ae5809",
                isSelected: checkedListAction1.includes("Export Excel")
                  ? true
                  : false,
              },
            ],
          },
          {
            authorizeId: "2be9c192-de81-4ada-b29c-8b28c534756c",
            authorizeNameEn: "Future Customer",
            authorizeNameTh: "ข้อมูลลูกค้าอนาคต",
            roleId: params.id,
            authorizeTopicId: "b9d77677-8a83-4059-6b91-1ec9b2803acb",
            permission: [
              {
                permissionId: "41fca05f-2546-48f9-a966-e04cee789e18",
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                authorizeId: "2be9c192-de81-4ada-b29c-8b28c534756c",
                isSelected: checkAllDashboard2 ? true : false,
              },
              {
                permissionId: "4bdcd67e-ed57-4ea2-99e5-50de44133805",
                permissionNameEn: "Export JPG",
                permissionNameTh: "นำออกข้อมูล",
                authorizeId: "2be9c192-de81-4ada-b29c-8b28c534756c",
                isSelected: checkedListDashboard2.includes("นำออกข้อมูล")
                  ? true
                  : false,
              },
              {
                permissionId: "cec591cf-c07a-449f-921c-012879cbb5d0",
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                authorizeId: "2be9c192-de81-4ada-b29c-8b28c534756c",
                isSelected: checkedListDashboard2.includes("ดู") ? true : false,
              },
            ],
          },
          {
            authorizeId: "4c88ce26-8879-49c6-9c10-8927d5edcefe",
            authorizeNameEn: "Future Customer",
            authorizeNameTh: "ข้อมูลลูกค้าอนาคต",
            roleId: params.id,
            authorizeTopicId: "f15f9069-71d0-a6e3-29a7-121206554679",
            permission: [
              {
                permissionId: "09fafc92-6188-4e19-b7f3-5f39f1551ac3",
                permissionNameEn: "Delete",
                permissionNameTh: "ลบ",
                authorizeId: "4c88ce26-8879-49c6-9c10-8927d5edcefe",
                isSelected: checkedListAction2.includes("ลบ") ? true : false,
              },
              {
                permissionId: "3db523e3-298d-4d34-8526-ae19f55971c1",
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                authorizeId: "4c88ce26-8879-49c6-9c10-8927d5edcefe",
                isSelected: checkAllAction2 ? true : false,
              },
              {
                permissionId: "64572647-744f-4d65-b717-4acf010fa132",
                permissionNameEn: "Edit",
                permissionNameTh: "แก้ไข",
                authorizeId: "4c88ce26-8879-49c6-9c10-8927d5edcefe",
                isSelected: checkedListAction2.includes("แก้ไข") ? true : false,
              },
              {
                permissionId: "6ef825fc-586b-45cc-8440-acae7a02a8d8",
                permissionNameEn: "Create",
                permissionNameTh: "สร้าง",
                authorizeId: "4c88ce26-8879-49c6-9c10-8927d5edcefe",
                isSelected: checkedListAction2.includes("สร้าง") ? true : false,
              },
              {
                permissionId: "6eff49b5-5235-4605-a957-f1e41b7cdd15",
                permissionNameEn: "Export Excel",
                permissionNameTh: "Export Excel",
                authorizeId: "4c88ce26-8879-49c6-9c10-8927d5edcefe",
                isSelected: checkedListAction2.includes("Export Excel")
                  ? true
                  : false,
              },
              {
                permissionId: "c640d521-4719-434e-a33f-98cf77ac45cb",
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                authorizeId: "4c88ce26-8879-49c6-9c10-8927d5edcefe",
                isSelected: checkedListAction2.includes("ดู") ? true : false,
              },
            ],
          },
          {
            authorizeId: "51f3d649-9139-4185-bece-290c388721ae",
            authorizeNameEn: "Satisfaction Data",
            authorizeNameTh: "ข้อมูลความพึงพอใจ",
            roleId: params.id,
            authorizeTopicId: "0dde5e71-42a7-f39c-8d63-1c855b36d07a",
            permission: [
              {
                permissionId: "1511d703-7a93-4ed5-b99c-c379cc7effe6",
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                authorizeId: "51f3d649-9139-4185-bece-290c388721ae",
                isSelected: checkedListRawData1.includes("ดู") ? true : false,
              },
              {
                permissionId: "274d0daa-d174-433d-81b7-560be83a2bb0",
                permissionNameEn: "Delete",
                permissionNameTh: "ลบ",
                authorizeId: "51f3d649-9139-4185-bece-290c388721ae",
                isSelected: checkedListRawData1.includes("ลบ") ? true : false,
              },
              {
                permissionId: "3991e48b-77bc-438c-aa58-9d258043423e",
                permissionNameEn: "Edit",
                permissionNameTh: "แก้ไข",
                authorizeId: "51f3d649-9139-4185-bece-290c388721ae",
                isSelected: checkedListRawData1.includes("แก้ไข")
                  ? true
                  : false,
              },
              {
                permissionId: "e315168f-1473-4f8f-acec-f1bb818fe6a7",
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                authorizeId: "51f3d649-9139-4185-bece-290c388721ae",
                isSelected: checkAllRawData1 ? true : false,
              },
              {
                permissionId: "ee71c193-b758-4ae3-ba18-fa284778bdd6",
                permissionNameEn: "Create",
                permissionNameTh: "สร้าง",
                authorizeId: "51f3d649-9139-4185-bece-290c388721ae",
                isSelected: checkedListRawData1.includes("สร้าง")
                  ? true
                  : false,
              },
            ],
          },
          {
            authorizeId: "52154fef-f905-4f8b-a771-c9522b1424a2",
            authorizeNameEn: "Master Data",
            authorizeNameTh: "ข้อมูล Master Data",
            roleId: params.id,
            authorizeTopicId: "0dde5e71-42a7-f39c-8d63-1c855b36d07a",
            permission: [
              {
                permissionId: "4dde21b1-ac0e-49d6-8906-b21e0a4c2f06",
                permissionNameEn: "Delete",
                permissionNameTh: "ลบ",
                authorizeId: "52154fef-f905-4f8b-a771-c9522b1424a2",
                isSelected: checkedListRawData2.includes("ลบ") ? true : false,
              },
              {
                permissionId: "58a1db0a-e49c-46ef-9ce3-fe896655d421",
                permissionNameEn: "Create",
                permissionNameTh: "สร้าง",
                authorizeId: "52154fef-f905-4f8b-a771-c9522b1424a2",
                isSelected: checkedListRawData2.includes("สร้าง")
                  ? true
                  : false,
              },
              {
                permissionId: "ac4ada2c-098c-471b-a3ef-23bcc4ea8f3d",
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                authorizeId: "52154fef-f905-4f8b-a771-c9522b1424a2",
                isSelected: checkAllRawData2 ? true : false,
              },
              {
                permissionId: "bf91c1ee-0de3-433b-ae16-cbcee381f9ca",
                permissionNameEn: "Edit",
                permissionNameTh: "แก้ไข",
                authorizeId: "52154fef-f905-4f8b-a771-c9522b1424a2",
                isSelected: checkedListRawData2.includes("แก้ไข")
                  ? true
                  : false,
              },
              {
                permissionId: "e0942a80-3bec-4861-aa18-84e519c28e39",
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                authorizeId: "52154fef-f905-4f8b-a771-c9522b1424a2",
                isSelected: checkedListRawData2.includes("ดู") ? true : false,
              },
            ],
          },
          {
            authorizeId: "7f87206e-6f08-45fd-a7ca-df59fcfa37c1",
            authorizeNameEn: "Customer Satisfaction Survey",
            authorizeNameTh: "Complaint Analysis Report",
            roleId: params.id,
            authorizeTopicId: "b9d77677-8a83-4059-6b91-1ec9b2803acb",
            permission: [
              {
                permissionId: "36176c78-f72b-45db-b2bf-7a0bc46720a5",
                permissionNameEn: "Export JPG",
                permissionNameTh: "นำออกข้อมูล",
                authorizeId: "7f87206e-6f08-45fd-a7ca-df59fcfa37c1",
                isSelected: checkedListDashboard5.includes("นำออกข้อมูล")
                  ? true
                  : false,
              },
              {
                permissionId: "5a55a747-c5c3-4ec8-a064-0593d0ceaf46",
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                authorizeId: "7f87206e-6f08-45fd-a7ca-df59fcfa37c1",
                isSelected: checkedListDashboard5.includes("ดู") ? true : false,
              },
              {
                permissionId: "66b30a2b-c00e-4dde-a4a5-8cd7fd8fc0e5",
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                authorizeId: "7f87206e-6f08-45fd-a7ca-df59fcfa37c1",
                isSelected: checkAllDashboard5 ? true : false,
              },
            ],
          },
          {
            authorizeId: "b35c94a7-8ebf-49c5-b7fd-3301c9a72f32",
            authorizeNameEn: "Current Customer",
            authorizeNameTh: "ข้อมูลลูกค้าปัจจุบัน",
            roleId: params.id,
            authorizeTopicId: "b9d77677-8a83-4059-6b91-1ec9b2803acb",
            permission: [
              {
                permissionId: "0dcecc29-b7f5-44fa-9a2f-99a0505d7843",
                permissionNameEn: "Export JPG",
                permissionNameTh: "นำออกข้อมูล",
                authorizeId: "b35c94a7-8ebf-49c5-b7fd-3301c9a72f32",
                isSelected: checkedListDashboard1.includes("นำออกข้อมูล")
                  ? true
                  : false,
              },
              {
                permissionId: "af125e6a-0941-43e3-88c1-dbc7e363a40c",
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                authorizeId: "b35c94a7-8ebf-49c5-b7fd-3301c9a72f32",
                isSelected: checkAllDashboard1 ? true : false,
              },
              {
                permissionId: "c977dbe7-5657-49ea-bb3f-4c2be1774d6c",
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                authorizeId: "b35c94a7-8ebf-49c5-b7fd-3301c9a72f32",
                isSelected: checkedListDashboard1.includes("ดู") ? true : false,
              },
            ],
          },
          {
            authorizeId: "b6e10430-fa76-4929-b8aa-4760b79223d7",
            authorizeNameEn: "Touch Point Data",
            authorizeNameTh: "ข้อมูล Touch Point",
            roleId: params.id,
            authorizeTopicId: "1cdf4ad0-8c1f-f4db-8965-26606ffa8ed1",
            permission: [
              {
                permissionId: "326f40c6-fbdb-4a46-81f2-1db3ac194523",
                permissionNameEn: "Create",
                permissionNameTh: "สร้าง",
                authorizeId: "b6e10430-fa76-4929-b8aa-4760b79223d7",
                isSelected: checkedListApp3.includes("สร้าง") ? true : false,
              },
              {
                permissionId: "6fcc8ea8-5d34-480b-9ad3-5554932a89e4",
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                authorizeId: "b6e10430-fa76-4929-b8aa-4760b79223d7",
                isSelected: checkedListApp3.includes("ดู") ? true : false,
              },
              {
                permissionId: "84d62a57-95a8-486e-9992-dfce304c13bd",
                permissionNameEn: "Edit",
                permissionNameTh: "แก้ไข",
                authorizeId: "b6e10430-fa76-4929-b8aa-4760b79223d7",
                isSelected: checkedListApp3.includes("แก้ไข") ? true : false,
              },
              {
                permissionId: "b0773431-9b98-4615-9787-d4ea8e826b10",
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                authorizeId: "b6e10430-fa76-4929-b8aa-4760b79223d7",
                isSelected: checkAllApp3 ? true : false,
              },
              {
                permissionId: "fb317010-a484-4cac-a8d1-19f7cc6c6afc",
                permissionNameEn: "Delete",
                permissionNameTh: "ลบ",
                authorizeId: "b6e10430-fa76-4929-b8aa-4760b79223d7",
                isSelected: checkedListApp3.includes("ลบ") ? true : false,
              },
            ],
          },
          {
            authorizeId: "fe16c0e1-ec0b-4d21-b4b6-77e08dfb0941",
            authorizeNameEn: "Complaint Analysis Report",
            authorizeNameTh: "Complaint Analysis Report",
            roleId: params.id,
            authorizeTopicId: "b9d77677-8a83-4059-6b91-1ec9b2803acb",
            permission: [
              {
                permissionId: "9346745f-f44d-4e89-9877-9be2a52a3b54",
                permissionNameEn: "Export JPG",
                permissionNameTh: "นำออกข้อมูล",
                authorizeId: "fe16c0e1-ec0b-4d21-b4b6-77e08dfb0941",
                isSelected: checkedListDashboard4.includes("นำออกข้อมูล")
                  ? true
                  : false,
              },
              {
                permissionId: "bd026531-4e35-4f5c-9157-48f9ed6a216b",
                permissionNameEn: "All",
                permissionNameTh: "ทำได้ทั้งหมด",
                authorizeId: "fe16c0e1-ec0b-4d21-b4b6-77e08dfb0941",
                isSelected: checkAllDashboard4 ? true : false,
              },
              {
                permissionId: "ffbd91d8-9d77-4404-819c-e90b424c0ed5",
                permissionNameEn: "View",
                permissionNameTh: "ดู",
                authorizeId: "fe16c0e1-ec0b-4d21-b4b6-77e08dfb0941",
                isSelected: checkedListDashboard4.includes("ดู") ? true : false,
              },
            ],
          },
        ],
      },
    };

    const res = await updateRoleUser(request);
    if (res?.data?.code === SUCCESS_CODE) {
      setOpenSuccessModal(true);
      setTimeout(() => {
        navigate(routes.user_management + `?menu=management&tab=role`);
      }, 2500);
    } else {
      setOpenFailModal(true);
    }

    setLoading(true);
    setTimeout(() => {
      closeLoader();
    }, 3000);
  };

  const fetchRoleByID = useCallback(
    async (id) => {
      const res = await getRoleId(id);

      if (res?.data?.code === SUCCESS_CODE) {
        const { objectValue } = res.data;
        setDataSource([objectValue]);

        if (objectValue?.permissionId) {
          setDisplayEnable(true);
        }
        form.setFieldsValue({
          permission: objectValue?.permissionId,
          status: objectValue?.recStatus === "A" ? true : false,
          roleNameTh: objectValue?.roleNameTh,
          description: objectValue?.description,
        });

        const { authorization } = res?.data.objectValue;

        for (let i = 0; i < authorization.length; i++) {
          if (
            // กรอกผ่าน Application
            authorization[i].authorizeTopicId ===
            "1cdf4ad0-8c1f-f4db-8965-26606ffa8ed1"
          ) {
            let arr = [];
            if (authorization[i].authorizeNameTh === "รายงานผลตัวชี้วัด") {
              arr = authorization[i].permission;
              for (let j = 0; j < arr.length; j++) {
                if (
                  arr[j].permissionNameTh === "ดู" &&
                  arr[j].isSelected
                ) {
                  setViewApp5(true);
                } else if (
                  arr[j].permissionNameTh === "สร้าง/แก้ไข" &&
                  arr[j].isSelected
                ) {
                  setCreateEditApp5(true);
                } else if (
                  arr[j].permissionNameTh === "เข้าถึงข้อมูลทุกปีงบประมาณ" &&
                  arr[j].isSelected
                ) {
                  setAllYearOfBudgetApp5(true);
                }
              }
            } else  
            if (authorization[i].authorizeNameTh === "รายงานผลการดำเนินงานตามแผนปฏิบัติการ") {
              arr = authorization[i].permission;
              for (let j = 0; j < arr.length; j++) {
                if (
                  arr[j].permissionNameTh === "ดู" &&
                  arr[j].isSelected
                ) {
                  setViewApp6(true);
                } else if (
                  arr[j].permissionNameTh === "สร้าง/แก้ไข" &&
                  arr[j].isSelected
                ) {
                  setCreateEditApp6(true);
                } else if (
                  arr[j].permissionNameTh === "เข้าถึงข้อมูลทุกปีงบประมาณ" &&
                  arr[j].isSelected
                ) {
                  setAllYearOfBudgetApp6(true);
                }
              }
            }else  
            if (authorization[i].authorizeNameTh === "รายงานจัดอันดับลูกค้าปัจจุบัน") {
              arr = authorization[i].permission;
              for (let j = 0; j < arr.length; j++) {
                if (
                  arr[j].permissionNameTh === "นำออกข้อมูล PDF" &&
                  arr[j].isSelected
                ) {
                  setCheckExportPDFApp7(true);
                }
              }
            }else  
            if (authorization[i].authorizeNameTh === "รายงานจัดอันดับลูกค้าอนาคต") {
              arr = authorization[i].permission;
              for (let j = 0; j < arr.length; j++) {
                if (
                  arr[j].permissionNameTh === "นำออกข้อมูล PDF" &&
                  arr[j].isSelected
                ) {
                  setCheckExportPDFApp8(true);
                }
              }
            } else  
            if (authorization[i].authorizeNameTh === "ข้อมูลลูกค้าปัจจุบัน") {
              // ข้อมูลลูกค้าปัจจุบัน
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllApp1(checkedAll);
                setCheckedListApp1(applicationOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListApp1(chk);
              }

              // loop over arr look for arr[j].permissionNameTh == เข้าถึงข้อมูลทุกนิคมได้
              // if found set checkAllEstate1 = true
              for (let j = 0; j < arr.length; j++) {
                if (
                  arr[j].permissionNameTh === "เข้าถึงข้อมูลทุกนิคมได้" &&
                  arr[j].isSelected
                ) {
                  setCheckAllEstate1(true);
                  break;
                }
              }
            } else if (
              authorization[i].authorizeNameTh === "ข้อมูลลูกค้าอนาคต"
            ) {
              //ข้อมูลลูกค้าอนาคต"
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || arr.length - 1 === c_true) {
                setCheckAllApp2(checkedAll);
                setCheckedListApp2(applicationOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListApp2(chk);
              }
            } else if (
              authorization[i].authorizeNameTh === "ข้อมูล Touch Point"
            ) {
              //"ข้อมูล Touch Point"
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllApp3(checkedAll);
                setCheckedListApp3(plainOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListApp3(chk);
              }
            } else if (
              authorization[i].authorizeNameTh === "ข้อมูลผู้มีส่วนได้ส่วนเสีย"
            ) {
              // ข้อมูลผู้มีส่วนได้ส่วนเสีย
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllApp4(checkedAll);
                setCheckedListApp4(plainOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListApp4(chk);
              }
            }
          } else if (
            // นำเข้าข้อมูล Raw Data
            authorization[i].authorizeTopicId ===
            "0dde5e71-42a7-f39c-8d63-1c855b36d07a"
          ) {
            let arr = [];
            if (authorization[i].authorizeNameTh === "ข้อมูลความพึงพอใจ") {
              // ข้อมูลความพึงพอใจ
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllRawData1(checkedAll);
                setCheckedListRawData1(plainOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListRawData1(chk);
              }
            } else if (
              authorization[i].authorizeNameTh === "ข้อมูล Master Data"
            ) {
              //ข้อมูล Master Data
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllRawData2(checkedAll);
                setCheckedListRawData2(plainOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListRawData2(chk);
              }
            }
          } else if (
            // ค้นหา / แก้ไขข้อมูล
            authorization[i].authorizeTopicId ===
            "f15f9069-71d0-a6e3-29a7-121206554679"
          ) {
            //
            let arr = [];
            if (authorization[i].authorizeNameTh === "ข้อมูลลูกค้าปัจจุบัน") {
              // ข้อมูลลูกค้าปัจจุบัน
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || arr.length - 1 === c_true) {
                setCheckAllAction1(checkedAll);
                setCheckedListAction1(plainOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListAction1(chk);
              }
            } else if (
              authorization[i].authorizeNameTh === "ข้อมูลลูกค้าอนาคต"
            ) {
              //ข้อมูลลูกค้าอนาคต
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }
              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllAction2(checkedAll);
                setCheckedListAction2(plainOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListAction2(chk);
              }
            }
          } else if (
            // Dashboard
            authorization[i].authorizeTopicId ===
            "b9d77677-8a83-4059-6b91-1ec9b2803acb"
          ) {
            let arr = [];
            if (authorization[i].authorizeNameTh === "ข้อมูลลูกค้าปัจจุบัน") {
              // ข้อมูลลูกค้าปัจจุบัน
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllDashboard1(checkedAll);
                setCheckedListDashboard1(dashboardOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListDashboard1(chk);
              }
            } else if (
              authorization[i].authorizeNameTh === "ข้อมูลลูกค้าอนาคต"
            ) {
              //ข้อมูลลูกค้าอนาคต
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllDashboard2(checkedAll);
                setCheckedListDashboard2(dashboardOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListDashboard2(chk);
              }
            } else if (authorization[i].authorizeNameTh === "Customer Visit") {
              //ข้อมูลลูกค้าอนาคต
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllDashboard3(checkedAll);
                setCheckedListDashboard3(dashboardOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListDashboard3(chk);
              }
            } else if (
              authorization[i].authorizeNameEn === "Complaint Analysis Report"
            ) {
              //ข้อมูลลูกค้าอนาคต
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllDashboard4(checkedAll);
                setCheckedListDashboard4(dashboardOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListDashboard4(chk);
              }
            } else if (
              authorization[i].authorizeNameEn ===
              "Customer Satisfaction Survey"
            ) {
              //ข้อมูลลูกค้าอนาคต
              arr = authorization[i].permission;
              let checkedAll = false;
              let c_true = 0;
              for (let j = 0; j < arr.length; j++) {
                if (arr[j].isSelected && arr[j].permissionNameEn === "All") {
                  checkedAll = true;
                }

                if (arr[j].isSelected && !arr[j].permissionNameEn === "All") {
                  c_true += 1;
                }
              }

              if (checkedAll || c_true === arr.length - 1) {
                setCheckAllDashboard5(checkedAll);
                setCheckedListDashboard5(dashboardOptions);
              } else {
                let chk = [];
                for (let j = 0; j < arr.length; j++) {
                  if (arr[j].isSelected) {
                    chk.push(arr[j].permissionNameTh);
                  } else {
                    chk.push("");
                  }
                }
                setCheckedListDashboard5(chk);
              }
            }
          }
        }
      } else {
        setDataSource([]);
      }
    },
    [setDataSource]
  );

  useEffect(() => {
    fetchRoleByID(params.id);
  }, [params.id, fetchRoleByID]);

  const closeLoader = useCallback(() => {
    setLoading(false);
    setOpenSuccessModal(false);
    setOpenFailModal(false);
  }, [setLoading, setOpenSuccessModal, setOpenFailModal]);

  const validateBeforeSubmit = useCallback(
    (values) => {
      if (values?.permission && values?.roleNameTh) {
        setSubmittable(true);
      } else {
        setSubmittable(false);
      }
    },
    [setSubmittable]
  );

  useEffect(() => {
    validateBeforeSubmit(values);
  }, [values, validateBeforeSubmit]);

  const onChangeStatus = (checked) => {};

  //กรอกผ่าน Application
  const onChangeListApp = (list, type) => {
    if (type === "app1") {
      setCheckedListApp1(list);
      setCheckAllApp1(list.length === applicationOptions.length);
    } else if (type === "app2") {
      setCheckedListApp2(list);
      setCheckAllApp2(list.length === applicationOptions.length);
    } else if (type === "app3") {
      setCheckedListApp3(list);
      setCheckAllApp3(list.length === plainOptions.length);
    } else {
      setCheckedListApp4(list);
      setCheckAllApp4(list.length === plainOptions.length);
    }
  };

  const onChangeAllEstate = (list,type) => {
    if (type === "app1") {
      setCheckAllEstate1(list.target.checked);
    }
  }

  const onCheckCreateEditApp = (e,type) => {
    if (type === "app5") {
      setCreateEditApp5(e.target.checked);
    }else
    if (type === "app6") {
      setCreateEditApp6(e.target.checked);
    }
  }

  const onCheckViewApp = (e,type) => {
    if (type === "app5") {
      setViewApp5(e.target.checked);
    }else
    if (type === "app6") {
      setViewApp6(e.target.checked);
    }
  }

  const onCheckAllYearOfBudgetApp = (e,type) => {
    if (type === "app5") {
      setAllYearOfBudgetApp5(e.target.checked);
    }else 
    if (type === "app6") {
      setAllYearOfBudgetApp6(e.target.checked);
    }
  }
  const onCheckExportPDFApp = (e,type) =>{
    if (type === "app7"){
      setCheckExportPDFApp7(e.target.checked);
    }else
    if (type === "app8"){
      setCheckExportPDFApp8(e.target.checked);
    }
  }
  const onCheckAllAppChange = (e, type) => {
    if (type === "app1") {
      setCheckedListApp1(e.target.checked ? applicationOptions : []);
      setCheckAllApp1(e.target.checked);
    } else if (type === "app2") {
      setCheckedListApp2(e.target.checked ? applicationOptions : []);
      setCheckAllApp2(e.target.checked);
    } else if (type === "app3") {
      setCheckedListApp3(e.target.checked ? plainOptions : []);
      setCheckAllApp3(e.target.checked);
    } else {
      setCheckedListApp4(e.target.checked ? plainOptions : []);
      setCheckAllApp4(e.target.checked);
    }
  };

  //นำเข้าข้อมูล Raw Data
  const onChangeListRawData = (list, type) => {
    if (type === "raw1") {
      setCheckedListRawData1(list);
      setCheckAllRawData1(list.length === plainOptions.length);
    } else {
      setCheckedListRawData2(list);
      setCheckAllRawData2(list.length === plainOptions.length);
    }
  };

  const onCheckAllRawDataChange = (e, type) => {
    if (type === "raw1") {
      setCheckedListRawData1(e.target.checked ? plainOptions : []);
      setCheckAllRawData1(e.target.checked);
    } else {
      setCheckedListRawData2(e.target.checked ? plainOptions : []);
      setCheckAllRawData2(e.target.checked);
    }
  };

  //ค้นหา/แก้ไขข้อมูล
  const onChangeListAction = (list, type) => {
    if (type === "action1") {
      setCheckedListAction1(list);
      setCheckAllAction1(list.length === plainOptions.length);
    } else {
      setCheckedListAction2(list);
      setCheckAllAction2(list.length === plainOptions.length);
    }
  };

  //Dashboard
  const onChangeListDashboard = (list, type) => {
    if (type === "dash1") {
      setCheckedListDashboard1(list);
      setCheckAllDashboard1(list.length === plainOptions.length);
    } else if (type === "dash2") {
      setCheckedListDashboard2(list);
      setCheckAllDashboard2(list.length === plainOptions.length);
    } else if (type === "dash3") {
      setCheckedListDashboard3(list);
      setCheckAllDashboard3(list.length === plainOptions.length);
    } else if (type === "dash4") {
      setCheckedListDashboard4(list);
      setCheckAllDashboard4(list.length === plainOptions.length);
    } else {
      setCheckedListDashboard5(list);
      setCheckAllDashboard5(list.length === plainOptions.length);
    }
  };

  const onCheckAllDashboardChange = (e, type) => {
    if (type === "dash1") {
      setCheckedListDashboard1(e.target.checked ? plainOptions : []);
      //   setIndeterminateDashboard1(false);
      setCheckAllDashboard1(e.target.checked);
    } else if (type === "dash2") {
      setCheckedListDashboard2(e.target.checked ? plainOptions : []);
      //   setIndeterminateDashboard2(false);
      setCheckAllDashboard2(e.target.checked);
    } else if (type === "dash3") {
      setCheckedListDashboard3(e.target.checked ? plainOptions : []);
      //   setIndeterminateDashboard3(false);
      setCheckAllDashboard3(e.target.checked);
    } else if (type === "dash4") {
      setCheckedListDashboard4(e.target.checked ? plainOptions : []);
      //    setIndeterminateDashboard4(false);
      setCheckAllDashboard4(e.target.checked);
    } else {
      setCheckedListDashboard5(e.target.checked ? plainOptions : []);
      //    setIndeterminateDashboard5(false);
      setCheckAllDashboard5(e.target.checked);
    }
  };

  // on change of permission
  const onChangePermision = (value) => {
    if (!value && value === undefined) {
      setDisplayEnable(false);
    } else {
      setDisplayEnable(true);
    }

    if (value === "a23126cb-5ef4-0c98-e3bc-840d81135073") {
      //admin
      setCheckedListApp1([]);
      setCheckedListApp2([]);
      setCheckedListApp3([]);
      setCheckedListApp4([]);
      setCheckAllApp1(true);
      setCheckAllApp2(true);
      setCheckAllApp3(true);
      setCheckAllApp4(true);

      setCheckedListRawData1([]);
      setCheckedListRawData2([]);
      setCheckAllRawData1(true);
      setCheckAllRawData2(true);

      setCheckedListAction1([]);
      setCheckedListAction2([]);
      setCheckAllAction1(true);
      setCheckAllAction2(true);

      setCheckedListDashboard1([]);
      setCheckedListDashboard2([]);
      setCheckedListDashboard3([]);
      setCheckedListDashboard4([]);
      setCheckedListDashboard5([]);
      setCheckAllDashboard1(true);
      setCheckAllDashboard2(true);
      setCheckAllDashboard3(true);
      setCheckAllDashboard4(true);
      setCheckAllDashboard5(true);
    }
    if (value === "498a2cd4-2097-4337-7b92-9c84bc1411d3") {
      //nikom
      setCheckedListApp1([Options.create, Options.watch]);
      setCheckedListApp2([Options.create, Options.watch]);
      setCheckedListApp3([Options.create, Options.watch]);
      setCheckedListApp4([Options.create, Options.watch]);
      setCheckAllApp1(false);
      setCheckAllApp2(false);
      setCheckAllApp3(false);
      setCheckAllApp4(false);

      setCheckedListRawData1([Options.create, Options.watch]);
      setCheckedListRawData2([Options.create, Options.watch]);
      setCheckAllRawData1(false);
      setCheckAllRawData2(false);

      setCheckedListAction1([Options.create, Options.watch]);
      setCheckedListAction2([Options.create, Options.watch]);
      setCheckAllAction1(false);
      setCheckAllAction2(false);

      setCheckedListDashboard1([]);
      setCheckedListDashboard2([]);
      setCheckedListDashboard3([]);
      setCheckedListDashboard4([]);
      setCheckedListDashboard5([]);
      setCheckAllDashboard1(true);
      setCheckAllDashboard2(true);
      setCheckAllDashboard3(true);
      setCheckAllDashboard4(true);
      setCheckAllDashboard5(true);
    } else if (value === "13cb9f4a-0bb9-4f5e-b2ff-961d5e93c741") {
      //manager
      setCheckedListApp1([Options.watch]);
      setCheckedListApp2([Options.watch]);
      setCheckedListApp3([Options.watch]);
      setCheckedListApp4([Options.watch]);
      setCheckAllApp1(false);
      setCheckAllApp2(false);
      setCheckAllApp3(false);
      setCheckAllApp4(false);

      setCheckedListRawData1([Options.watch]);
      setCheckedListRawData2([Options.watch]);
      setCheckAllRawData1(false);
      setCheckAllRawData2(false);

      setCheckedListAction1([Options.watch]);
      setCheckedListAction2([Options.watch]);
      setCheckAllAction1(false);
      setCheckAllAction2(false);

      setCheckedListDashboard1([]);
      setCheckedListDashboard2([]);
      setCheckedListDashboard3([]);
      setCheckedListDashboard4([]);
      setCheckedListDashboard5([]);
      setCheckAllDashboard1(true);
      setCheckAllDashboard2(true);
      setCheckAllDashboard3(true);
      setCheckAllDashboard4(true);
      setCheckAllDashboard5(true);
    } else if (!value || value === undefined) {
      setCheckedListApp1([]);
      setCheckedListApp2([]);
      setCheckedListApp3([]);
      setCheckedListApp4([]);
      setCheckAllApp1(false);
      setCheckAllApp2(false);
      setCheckAllApp3(false);
      setCheckAllApp4(false);

      setCheckedListRawData1([]);
      setCheckedListRawData2([]);
      setCheckAllRawData1(false);
      setCheckAllRawData2(false);

      setCheckedListAction1([]);
      setCheckedListAction2([]);
      setCheckAllAction1(false);
      setCheckAllAction2(false);

      setCheckedListDashboard1([]);
      setCheckedListDashboard2([]);
      setCheckedListDashboard3([]);
      setCheckedListDashboard4([]);
      setCheckedListDashboard5([]);
      setCheckAllDashboard1(false);
      setCheckAllDashboard2(false);
      setCheckAllDashboard3(false);
      setCheckAllDashboard4(false);
      setCheckAllDashboard5(false);
    }
  };

  return (
    <WithSidebar>
      <div className="add_role_management">
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24} vertical="center">
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                    setPreviousPage(
                      routes.user_management + `?menu=management&tab=role`
                    );
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"แก้ไขสิทธิ์"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "การจัดการผู้ใช้งาน",
                },
                {
                  title: (
                    <Link to={routes.user_management}>
                      การจัดการบทบาทและสิทธิ์การเข้าถึง
                    </Link>
                  ),
                },
                {
                  title: <span className="pr_green">แก้ไขสิทธิ์</span>,
                },
              ]}
            />
          </Col>

          <Form
            form={form}
            onFinish={onFinish}
            layout="vertical"
            style={{ width: "100%", padding: "0 30px" }}
            colon={false}
          >
            <Col span={24}>
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  <Space>
                    <Button
                      onClick={() => {
                        setOpenCancelModal(true);
                        setPreviousPage(
                          routes.user_management + `?menu=management&tab=role`
                        );
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={!submittable}
                      loading={loading}
                    >
                      บันทึก
                    </Button>
                  </Space>
                </Col>
              </Row>

              <Row gutter={[8]} className="card">
                <Col span={24}>
                  <Heading text={"กำหนดสิทธ์"} size={4} style={{ margin: 0 }} />
                  <Divider />
                </Col>
                <Col span={24}>
                  <Row gutter={[24, 18]}>
                    <Col span={8}>
                      <Form.Item
                        label="Permission"
                        name={"permission"}
                        rules={[{ required: true, message: "โปรดระบุ" }]}
                      >
                        <Select
                          allowClear
                          showSearch={false}
                          className="w-full"
                          placeholder="กรุณาเลือก Permission"
                          optionFilterProp="children"
                          onChange={onChangePermision}
                          hasfeedback="true"
                        >
                          {permissions?.map((option, i) => {
                            return (
                              <Option key={option.dataId} value={option.dataId}>
                                {option.dataDetailTh}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name={"roleNameTh"}
                        label="ชื่อ Role"
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input
                          placeholder="ชื่อ Role"
                          disabled={
                            !form.getFieldValue(["permission"]) ? true : false
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="สถานะ Role" name={"status"}>
                        <Switch
                          // defaultChecked
                          onChange={onChangeStatus}
                          checked={form.getFieldValue(["status"])}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="รายละเอียด Role" name={"description"}>
                        <TextArea rows={3} placeholder="รายละเอียด Role" />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
              {displayEnable && (
                <>
                  <Row gutter={[8]} className="card" style={{ marginTop: 15 }}>
                    <Col span={24}>
                      <Heading
                        text={"การกำหนดสิทธ์การเข้าถึง"}
                        size={4}
                        style={{ margin: 0 }}
                      />
                      <Divider />
                    </Col>
                    <Col span={24}>
                      <Collapse
                        bordered={false}
                        defaultActiveKey={["1"]}
                        expandIconPosition={"right"}
                        expandIcon={({ isActive }) => (
                          <CaretRightOutlined rotate={isActive ? 90 : 0} />
                        )}
                        style={{
                          background: token.colorBgContainer,
                        }}
                      >
                        <Panel
                          header={
                            <>
                              <span className="box-border"></span>กรอกผ่าน
                              Application
                            </>
                          }
                          key="1"
                          style={panelStyle}
                        >
                          <Row gutter={[24, 18]}>
                            <Col span={24}>
                              <Form.Item
                                label="ข้อมูลลูกค้าปัจจุบัน"
                                name={"app1"}
                              >
                                <CheckboxGroup
                                  options={applicationOptions}
                                  value={checkedListApp1}
                                  onChange={(event) => {
                                    onChangeListApp(event, "app1");
                                  }}
                                  disabled={checkAllApp1}
                                />
                                <Checkbox
                                  indeterminate={indeterminateApp1}
                                  onChange={(event) => {
                                    onCheckAllAppChange(event, "app1");
                                  }}
                                  checked={checkAllApp1}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>

                                <Checkbox
                                  onChange={(event) => {
                                    onChangeAllEstate(event, "app1");
                                  }}
                                  checked={checkAllEstate1}
                                >
                                  เข้าถึงข้อมูลทุกนิคมได้
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="ข้อมูลลูกค้าอนาคต"
                                name={"app2"}
                              >
                                <CheckboxGroup
                                  options={applicationOptions}
                                  value={checkedListApp2}
                                  onChange={(event) => {
                                    onChangeListApp(event, "app2");
                                  }}
                                  disabled={checkAllApp2}
                                />
                                <Checkbox
                                  indeterminate={indeterminateApp2}
                                  onChange={(event) => {
                                    onCheckAllAppChange(event, "app2");
                                  }}
                                  checked={checkAllApp2}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="ข้อมูล Touch Point"
                                name={"app3"}
                              >
                                <CheckboxGroup
                                  options={plainOptions}
                                  value={checkedListApp3}
                                  onChange={(event) => {
                                    onChangeListApp(event, "app3");
                                  }}
                                  disabled={checkAllApp3}
                                />
                                <Checkbox
                                  indeterminate={indeterminateApp3}
                                  onChange={(event) => {
                                    onCheckAllAppChange(event, "app3");
                                  }}
                                  checked={checkAllApp3}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="ข้อมูลผู้มีส่วนได้ส่วนเสีย"
                                name={"app4"}
                              >
                                <CheckboxGroup
                                  options={plainOptions}
                                  value={checkedListApp4}
                                  onChange={(event) => {
                                    onChangeListApp(event, "app4");
                                  }}
                                  disabled={checkAllApp4}
                                />
                                <Checkbox
                                  indeterminate={indeterminateApp4}
                                  onChange={(event) => {
                                    onCheckAllAppChange(event, "app4");
                                  }}
                                  checked={checkAllApp4}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="รายงานผลตัวชี้วัด"
                                name={"app5"}
                              >
                                <Checkbox style={{ width: "140px" }}
                                  onChange={(event) => {
                                    onCheckCreateEditApp(event, "app5");
                                  }}
                                  checked={createEditApp5}
                                >
                                  สร้าง/แก้ไข
                                </Checkbox>

                                <Checkbox style={{ width: "140px" }}
                                  onChange={(event) => {
                                    onCheckViewApp(event, "app5");
                                  }}
                                  checked={viewApp5}
                                >
                                  ดู
                                </Checkbox>

                                <Checkbox 
                                  onChange={(event) => {
                                    onCheckAllYearOfBudgetApp(event, "app5");
                                  }}
                                  checked={allYearOfBudgetApp5}
                                >
                                  เข้าถึงข้อมูลทุกปีงบประมาณ
                                </Checkbox>


                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="รายงานผลการดำเนินงานตามแผนปฏิบัติการ"
                                name={"app6"}
                              >
                                <Checkbox style={{ width: "140px" }}
                                  onChange={(event) => {
                                    onCheckCreateEditApp(event, "app6");
                                  }}
                                  checked={createEditApp6}
                                >
                                  สร้าง/แก้ไข
                                </Checkbox>

                                <Checkbox style={{ width: "140px" }}
                                  onChange={(event) => {
                                    onCheckViewApp(event, "app6");
                                  }}
                                  checked={viewApp6}
                                >
                                  ดู
                                </Checkbox>

                                <Checkbox 
                                  onChange={(event) => {
                                    onCheckAllYearOfBudgetApp(event, "app6");
                                  }}
                                  checked={allYearOfBudgetApp6}
                                >
                                  เข้าถึงข้อมูลทุกปีงบประมาณ
                                </Checkbox>


                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="รายงานจัดอันดับลูกค้าปัจจุบัน"
                                name={"app7"}
                              >
                                <Checkbox style={{ width: "140px" }}
                                  onChange={(event) => {
                                    onCheckExportPDFApp(event, "app7");
                                  }}
                                  checked={checkExportPDFApp7}
                                >
                                  Export PDF
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="รายงานจัดอันดับลูกค้าอนาคต"
                                name={"app8"}
                              >
                                <Checkbox style={{ width: "140px" }}
                                  onChange={(event) => {
                                    onCheckExportPDFApp(event, "app8");
                                  }}
                                  checked={checkExportPDFApp8}
                                >
                                  Export PDF
                                </Checkbox>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Panel>

                        <Panel
                          header={
                            <>
                              <span className="box-border"></span>นำเข้าข้อมูล
                              Raw Data
                            </>
                          }
                          key="2"
                          style={panelStyle}
                        >
                          <Row gutter={[24, 18]}>
                            <Col span={24}>
                              <Form.Item
                                label="ข้อมูลความพึงพอใจ"
                                name={"raw1"}
                              >
                                <CheckboxGroup
                                  options={plainOptions}
                                  value={checkedListRawData1}
                                  onChange={(event) => {
                                    onChangeListRawData(event, "raw1");
                                  }}
                                  disabled={checkAllRawData1}
                                />
                                <Checkbox
                                  indeterminate={indeterminateRawData1}
                                  onChange={(event) => {
                                    onCheckAllRawDataChange(event, "raw1");
                                  }}
                                  checked={checkAllRawData1}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="ข้อมูล Master Data"
                                name={"raw2"}
                              >
                                <CheckboxGroup
                                  options={plainOptions}
                                  value={checkedListRawData2}
                                  onChange={(event) => {
                                    onChangeListRawData(event, "raw2");
                                  }}
                                  disabled={checkAllRawData2}
                                />
                                <Checkbox
                                  indeterminate={indeterminateRawData2}
                                  onChange={(event) => {
                                    onCheckAllRawDataChange(event, "raw2");
                                  }}
                                  checked={checkAllRawData2}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Panel>

                        {/* <Panel
                          header={
                            <>
                              <span className="box-border"></span>ค้นหา /
                              แก้ไขข้อมูล
                            </>
                          }
                          key="3"
                          style={panelStyle}
                        >
                          <Row gutter={[24, 18]}>
                            <Col span={24}>
                              <Form.Item
                                label="ข้อมูลลูกค้าปัจจุบัน"
                                name={"action1"}
                              >
                                <CheckboxGroup
                                  options={plainOptions}
                                  value={checkedListAction1}
                                  onChange={(event) => {
                                    onChangeListAction(event, "action1");
                                  }}
                                  disabled={checkAllAction1}
                                />
                                <Checkbox
                                  indeterminate={indeterminateAction1}
                                  onChange={(event) => {
                                    onCheckAllActionChange(event, "action1");
                                  }}
                                  checked={checkAllAction1}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="ข้อมูลลูกค้าอนาคต"
                                name={"action2"}
                              >
                                <CheckboxGroup
                                  options={plainOptions}
                                  value={checkedListAction2}
                                  onChange={(event) => {
                                    onChangeListAction(event, "action2");
                                  }}
                                  disabled={checkAllAction2}
                                />
                                <Checkbox
                                  indeterminate={indeterminateAction2}
                                  onChange={(event) => {
                                    onCheckAllActionChange(event, "action2");
                                  }}
                                  checked={checkAllAction2}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Panel> */}

                        <Panel
                          header={
                            <>
                              <span className="box-border"></span>Dashboard
                            </>
                          }
                          key="4"
                          style={panelStyle}
                        >
                          <Row gutter={[24, 18]}>
                            <Col span={24}>
                              <Form.Item
                                label="ข้อมูลลูกค้าปัจจุบัน"
                                name={"dash1"}
                              >
                                <CheckboxGroup
                                  options={dashboardOptions}
                                  value={checkedListDashboard1}
                                  onChange={(event) => {
                                    onChangeListDashboard(event, "dash1");
                                  }}
                                  disabled={checkAllDashboard1}
                                />
                                <Checkbox
                                  indeterminate={indeterminateDashboard1}
                                  onChange={(event) => {
                                    onCheckAllDashboardChange(event, "dash1");
                                  }}
                                  checked={checkAllDashboard1}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="ข้อมูลลูกค้าอนาคต"
                                name={"dash2"}
                              >
                                <CheckboxGroup
                                  options={dashboardOptions}
                                  value={checkedListDashboard2}
                                  onChange={(event) => {
                                    onChangeListDashboard(event, "dash2");
                                  }}
                                  disabled={checkAllDashboard2}
                                />
                                <Checkbox
                                  indeterminate={indeterminateDashboard2}
                                  onChange={(event) => {
                                    onCheckAllDashboardChange(event, "dash2");
                                  }}
                                  checked={checkAllDashboard2}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item label="Customer Visit" name={"dash3"}>
                                <CheckboxGroup
                                  options={dashboardOptions}
                                  value={checkedListDashboard3}
                                  onChange={(event) => {
                                    onChangeListDashboard(event, "dash3");
                                  }}
                                  disabled={checkAllDashboard3}
                                />
                                <Checkbox
                                  indeterminate={indeterminateDashboard3}
                                  onChange={(event) => {
                                    onCheckAllDashboardChange(event, "dash3");
                                  }}
                                  checked={checkAllDashboard3}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="Complaint Analysis Report"
                                name={"dash4"}
                              >
                                <CheckboxGroup
                                  options={dashboardOptions}
                                  value={checkedListDashboard4}
                                  onChange={(event) => {
                                    onChangeListDashboard(event, "dash4");
                                  }}
                                  disabled={checkAllDashboard4}
                                />
                                <Checkbox
                                  indeterminate={indeterminateDashboard4}
                                  onChange={(event) => {
                                    onCheckAllDashboardChange(event, "dash4");
                                  }}
                                  checked={checkAllDashboard4}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="Customer Satisfaction Survey"
                                name={"dash5"}
                              >
                                <CheckboxGroup
                                  options={dashboardOptions}
                                  value={checkedListDashboard5}
                                  onChange={(event) => {
                                    onChangeListDashboard(event, "dash5");
                                  }}
                                  disabled={checkAllDashboard5}
                                />
                                <Checkbox
                                  indeterminate={indeterminateDashboard5}
                                  onChange={(event) => {
                                    onCheckAllDashboardChange(event, "dash5");
                                  }}
                                  checked={checkAllDashboard5}
                                >
                                  ทำได้ทั้งหมด
                                </Checkbox>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Panel>
                      </Collapse>
                    </Col>
                  </Row>
                </>
              )}
            </Col>
          </Form>
        </Row>

        <SuccessModal
          open={openSuccessModal}
          setOpen={setOpenSuccessModal}
          title="สำเร็จ"
          subTitle={"ทำรายการสำเร็จ"}
        />

        <FailModal open={openFailModal} setOpen={setOpenFailModal} />
      </div>
    </WithSidebar>
  );
};

export default EditUserRoleManagement;
